import requestProvider from "./axiosHandler";
const reportBase = '/report'

const appointmentReports = (list) => {
    return requestProvider
        .post(`${reportBase}/appointment`, list)
}

const productionLineReports = (list) => {
     return requestProvider
         .post(`${reportBase}/production`, list)
}

const warehouseReports = (list) => {
    return requestProvider
        .post(`${reportBase}/warehouse`, list)
}

const warehouseStockReports = (list) => {
    return requestProvider
        .post(`${reportBase}/stock`, list)
}

const involvedBrandOfferReports = (list) => {
    return requestProvider
        .post(`${reportBase}/stock-count-on-bid`, list)
}

const notInvolvedBrandOfferReports = (list) => {
    return requestProvider
        .post(`${reportBase}/not-used-stock`, list)
}

const totalProfitBySellingReports = (list) => {
    return requestProvider
        .post(`${reportBase}/ciro`, list)
}

const purchaseCostReports = (list) => {
    return requestProvider
        .post(`${reportBase}/stock-cost`, list)
}

const nonZeroStock = () => {
    return requestProvider
        .get(`${reportBase}/non-zero-stock`)
}

const initLanding = () => {
    return requestProvider
        .get(`${reportBase}/init`)
}

const diffOfferAndShipping = (list) => {
    return requestProvider
        .post(`${reportBase}/difference-bid-so`, list)
}

const brandBasedOffers = (list) => {
    return requestProvider
        .post(`${reportBase}/brand`, list);
}

const getCustomerBase = (list) => {
    return requestProvider
        .post(`${reportBase}/customer-base`, list);
}

const customerBids = (list) => {
    return requestProvider
        .post(`${reportBase}/customer-bids`, list);
};

const customerStockBrands = (list) => {
    return requestProvider
        .post(`${reportBase}/customer-stocks-brand`, list);
}

const customerAppointment = (list) => {
    return requestProvider
        .post(`${reportBase}/customer-appointment`, list);
}

export {
    appointmentReports,
    involvedBrandOfferReports,
    notInvolvedBrandOfferReports,
    totalProfitBySellingReports,
    productionLineReports,
    purchaseCostReports,
    warehouseReports,
    warehouseStockReports,
    nonZeroStock,
    initLanding,
    diffOfferAndShipping,
    brandBasedOffers,
    getCustomerBase,
    customerBids,
    customerStockBrands,
    customerAppointment
}